module.exports = __webpack_public_path__ + "img/no-item.cf84ec99.png";